export const BUILDING_GROUPS_ACTION_REMOVE = 'delete'

export const BUILDING_GROUPS_ACTION_EDIT_MANAGERS = 'update_responsible_users'

export const BUILDING_GROUPS_ACTION_EDIT_BUILDINGS = 'update_buildings'

export const BUILDING_GROUPS_ACTION_REMOVE_MASS = 'delete_mass'

export const BUILDING_GROUPS_ACTION_EDIT_MANAGERS_MASS =
  'update_responsible_users_mass'

export const BUILDING_GROUPS_ACTION_EDIT_BUILDINGS_MASS =
  'update_buildings_mass'

export const BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP = 'delete_from_group'

export const BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP_MASS =
  'delete_from_group_mass'

export const BUILDING_GROUP_TABLE_MASS_ACTION_NAMES = {
  [BUILDING_GROUPS_ACTION_EDIT_BUILDINGS]: 'update_buildings',
  [BUILDING_GROUPS_ACTION_EDIT_BUILDINGS_MASS]: 'update_buildings',
  [BUILDING_GROUPS_ACTION_EDIT_MANAGERS]: 'update_responsible_users',
  [BUILDING_GROUPS_ACTION_EDIT_MANAGERS_MASS]: 'update_responsible_users',
  [BUILDING_GROUPS_ACTION_REMOVE]: 'delete',
  [BUILDING_GROUPS_ACTION_REMOVE_MASS]: 'delete',
}
